
























import Comment from '@/views/comment/components/comment.vue'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: {
      Comment,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 评论数据
      commentData = computed(() => this.goodsData.value.commentData)

      // 点击更多
      handleMoreClick = () => {
        navigateTo('CommentIndex', {
          id: this.goodsData.value.commodityId,
        })
      }
    },
)
